import React from 'react';
import CoverImage from './CoverImage';
import '../styles/BookCard.css';

function BookCard({ biblioId, isbn, title, author, itemCount, dateAdded, onClick }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      id={`book-${biblioId}`}
      className="book-card-unified"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      aria-label={`${title}${author ? `, by ${author}` : ''}`}
    >
      <div className="book-card-unified__cover">
        <CoverImage
          biblioId={biblioId}
          isbn={isbn}
          alt={title}
          width={130}
          height={190}
          sizeCode="M"
        />
      </div>
      <div className="book-card-unified__info">
        <p className="book-card-unified__title">{title}</p>
        {author && <p className="book-card-unified__author">{author}</p>}
        {dateAdded && (
          <p className="book-card-unified__meta">
            Added:{' '}
            {new Date(dateAdded).toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            })}
          </p>
        )}
        {itemCount != null && (
          <p className="book-card-unified__meta book-card-unified__meta--copies">
            {itemCount} {itemCount === 1 ? 'copy' : 'copies'}
          </p>
        )}
      </div>
    </div>
  );
}

export default BookCard;
